import main from '@/store/main';
import quill from '@/store/quill';
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        main: main,
        quill: quill,
    }
})

export default store;
